import * as React from 'react';
export default function SvgScissors() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 6.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM4 8a3 3 0 116 0 3 3 0 01-6 0zM7 14.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM4 16a3 3 0 116 0 3 3 0 01-6 0z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.834 6.28a.75.75 0 01-.114 1.054l-10.25 8.25a.75.75 0 01-.94-1.168l10.25-8.25a.75.75 0 011.054.114z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.388 8.567a.75.75 0 011.045-.18l10.25 7.25a.75.75 0 11-.866 1.225l-10.25-7.25a.75.75 0 01-.18-1.045z",
    fill: "currentColor"
  }));
}